// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"a59940f3","239":"e39fb35b","455":"2186bbf4","545":"cca76150","644":"4a819ba3","961":"2bf736f9"}[chunkId] + ".chunk.js";
};